export default {
  element: {
    ASK_HEALTH_QUESTION_LINK: 'AskHealthQuestionLink',
    AVATAR: 'Avatar',
    BUTTON: 'Button',
    CONTACT_US: 'ContactUs',
    EDIT: 'Edit',
    EMAIL: 'Email',
    ENROLL_PROGRAM: 'EnrollProgram',
    FACEBOOK: 'Facebook',
    FIND_OTHERS_LINK: 'FindOthersLink',
    FOLLOW: 'Follow',
    LIKE: 'Like',
    LINK: 'Link',
    LOGIN: 'Login',
    PROGRAM_MODULE_NEXT_LINK: 'ProgramModuleNextLink',
    PROGRAM_MODULE_PREVIOUS_LINK: 'ProgramModulePreviousLink',
    PROGRAM_SECTION_MARK_AS_COMPLETE: 'ProgramSectionMarkAsComplete',
    PROGRAM_SECTION_TOGGLE_SECTION: 'ProgramSectionToggleSection',
    PROMO_IMAGE: 'PromoImage',
    REPLY_HIDDEN_LINK: 'ReplyHiddenLink',
    REPLY_SUBMIT: 'SubmitReply',
    REPLY: 'Reply',
    REPORT: 'Report',
    SIGNUP: 'Signup',
    TAKE_HEALTH_NEEDS_QUIZ_LINK: 'TakeHealthNeedsQuizLink',
    UNTRACKED: 'UNTRACKED',
    USER_LINK: 'UserLink',
    VOTE: 'Vote',
    WRITE: 'Write',
  },
  section: {
    ABOVE_FOOTER: 'AboveFooter',
    BANNER: 'Banner',
    CAMPAIGN: 'Campaign',
    COMMUNITY_ABOUT: 'CommunityAbout',
    COMMUNITY_BOX: 'CommunityBox',
    COMMUNITY_HOME_MEMBERS: 'CommunityHomeMembers',
    COMMUNITY_HOME_POLL: 'CommunityHomePoll',
    COMMUNITY_HOME_POST: 'CommunityHomePost',
    COMMUNITY_MEMBERS: 'CommunityMembers',
    COMMUNITY_POSTS_POLL: 'CommunityPostsPoll',
    COMMUNITY_POSTS_VISITOR_PROMPT: 'CommunityPostsVisitorPrompt',
    COMMUNITY: 'Community',
    CONVERSION_HIDDEN_RESP: 'ConvBoxReply',
    CONVERSION_LOWER: 'ConvBoxLower',
    CONVERSION_SIDEBAR: 'ConvBoxSidebar',
    CONVERSION_UPPER: 'ConvBoxUpper',
    CONVERSION: 'ConvBox',
    DISCOVER: 'DiscoverHealth',
    FLOATING_BOX: 'FloatingBox',
    HEADER: 'Header',
    LOCAL: 'Local',
    LOGIN_REDIRECT: 'LoginBox',
    MOBILE_NAV: 'MobileNav',
    NEXT_POSTS: 'Next Posts',
    POLL_REPLY: 'PollReply',
    POLL: 'Poll',
    POLLS: 'Polls',
    POST_REPLY: 'PostReply',
    POST: 'Post',
    POSTS: 'Posts',
    PROGRAM_MODULE_SECTION: 'ProgramModuleSection',
    PROGRAM_OVERVIEW: 'ProgramOverview',
    RELATED_WIDGET: 'RelatedCommunity',
    REPLY: 'Reply',
    SEARCH_COMMUNITY_CARD: 'SearchCommunityCard',
    SEARCH_HIT: 'SearchHit',
    SEARCH_MEMBERS_RESULTS_PAGE: 'SearchMembersResultsPage',
    SEARCH_TIPS: 'SearchTips',
    SIGNUP_PAGE: 'SignupPage',
    TAGS_PAGE_SIDEBAR: 'TagsPageSidebar',
    UNTRACKED: 'UNTRACKED',
    USER_LIST: 'UserList',
  },
};

export type signupContextType = {
  element?: string;
  section: string;
}
